import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'
import state from './state'

// import modules from "./modules";
// import kefu from './modules/kefu'
import knowledgebase from './modules/knowledgebase'
import monitor from './modules/monitor'
// import im from './modules/im'
// import statistics from './modules/statistics'
// import stomp from './modules/stomp'
import mqtt from './modules/mqtt'
// import webrtc from './modules/webrtc'
import ticket from './modules/ticket'
import emoticon from './modules/emoticon'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state,
  getters,
  actions,
  // modules,
  modules: {
    // kefu,
    knowledgebase,
    monitor,
    // im,
    // statistics,
    // stomp,
    mqtt,
    // webrtc,
    ticket,
    emoticon
  },
  mutations,
  strict: debug
})
